export default "__VITE_ASSET__Dg0F74$Y__"